// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ece73913832cb6dfadef","453":"ab3e9dda170cf7db96e7"}[chunkId] + ".js";
};